(function () {
  function setupWizard(root) {
    if (!root || root.dataset.vmwBoot === 'true') return;
    root.dataset.vmwBoot = 'true';
    const initWizard = () => {
    /* ------------------------------------------------------------------
       Yanıtlar YALNIZCA aşağıdaki `answers` nesnesinde tutulur.
       Çerez yok, storage yok, URL'e yazma yok, yanıt gönderen istek yok.
       İzinli Analytics yalnızca kullanım akışını ölçer; cevapları almaz.
       Sayfa yenilenince her şey sıfırlanır — istenen davranış budur.
       ------------------------------------------------------------------ */
    if (root.dataset.vmwInit) return;
    root.dataset.vmwInit = '1';

    const dataEl = document.querySelector('[data-vmw-catalog="' + root.dataset.vmwSection + '"]');
    if (!dataEl) return;

    // Katalog bozuksa SESSİZCE ölme: eskiden burada `return` vardı ve sihirbaz
    // adımları HTML'deki halleriyle üst üste bırakıp iki "Devam" gösteriyordu.
    let catalog;
    try {
      catalog = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[vanemar-wizard] Katalog JSON okunamadı, sihirbaz gizlendi:', e);
      root.hidden = true;
      return;
    }

    const form = root.querySelector('[data-vmw-form]');
    const progress = root.querySelector('[data-vmw-progress]');
    const progressBar = root.querySelector('[data-vmw-progress-bar]');
    const progressText = root.querySelector('[data-vmw-progress-text]');
    const resultEl = root.querySelector('[data-vmw-result]');
    const statusEl = root.querySelector('[data-vmw-status]');
    const addAllBtn = root.querySelector('[data-vmw-add-all]');
    const addAllLabel = root.querySelector('[data-vmw-add-all-label]');

    const config = catalog.config || {};
    const strings = config.strings || {};

    // Sihirbazın tüm hafızası. Başka hiçbir yerde kopyası yok.
    // qty    = { needId: hesaplanan sensör adedi }
    // detail = { needId: "Kamaralar (4), Mutfak (1)" } — sonuçtaki gerekçe satırı
    const answers = { needs: [], qty: {}, detail: {}, skipGateway: false };

    /* ---------- Adım gezinme ----------
       Adımlar sabit numaralı değil: kullanıcı 1. adımda ne seçtiyse, yalnızca
       o konuların adımları sırayla gösterilir. Akış her seçim değişiminde
       yeniden kurulur. */
    const needsStep = root.querySelector('[data-vmw-step="needs"]');
    const resultStep = root.querySelector('[data-vmw-step="result"]');
    const needStepEls = {};
    const needTemplates = {};
    root.querySelectorAll('[data-vmw-need-template]').forEach((template) => {
      // "Soru sorma" konularının template'i yoktur ve sonuçta doğrudan bir
      // adet ürün üretir. Yanlışlıkla boş bırakılmış choices/areas adımlarını
      // da akışa sokmayalım; aksi halde kullanıcı başlıktan ibaret bir ekrana
      // düşer. Her iki durumda da readNeedAnswer varsayılan adet olan 1'i verir.
      const hasStep = template.content.querySelector('[data-vmw-need-step]');
      const hasAnswer = template.content.querySelector('[data-vmw-choice], [data-vmw-area]');
      if (hasStep && hasAnswer) needTemplates[template.dataset.vmwNeedTemplate] = template;
    });

    const ensureNeedStep = (id) => {
      if (needStepEls[id]) return needStepEls[id];
      const template = needTemplates[id];
      if (!template) return null;
      const fragment = template.content.cloneNode(true);
      const step = fragment.querySelector('[data-vmw-need-step]');
      if (!step) return null;
      resultStep.before(fragment);
      needStepEls[id] = step;
      return step;
    };

    let flow = [needsStep, resultStep];
    let current = 0;

    // Lifecycle metrics only: never pass `answers`, need IDs, choices, room
    // names or sensor quantities to Analytics. Consent is checked centrally.
    let analyticsStartedAt = null;
    let analyticsCompleted = false;
    let analyticsRun = 1;
    let analyticsViewed = false;
    const trackWizard = (name, extra) => {
      try {
        return window.VanemarAnalytics?.track(name, {
          wizard_run: analyticsRun,
          ...extra
        }) || false;
      } catch (error) {
        return false;
      }
    };
    const trackView = () => {
      if (!analyticsViewed) analyticsViewed = trackWizard('wizard_view');
    };
    const trackStep = () => trackWizard('wizard_step_view', {
      wizard_step: current + 1,
      wizard_steps_total: flow.length,
      wizard_step_type: current === 0 ? 'needs' : (flow[current] === resultStep ? 'result' : 'question')
    });
    const startTracking = () => {
      if (analyticsStartedAt !== null) return;
      trackView(); // An interaction also proves the wizard was seen.
      if (trackWizard('wizard_start')) {
        analyticsStartedAt = Date.now();
        trackStep();
      }
    };
    const elapsed = () => analyticsStartedAt === null ? 0 : Date.now() - analyticsStartedAt;

    // Measure the heading's visibility, not initialization 600px offscreen.
    // A large wizard can be taller than the viewport, so observing its entire
    // surface would make a visibility ratio unreachable on small devices.
    const viewTarget = root.querySelector('.vmw-head') || needsStep;
    let viewTimer = null;
    let viewVisible = false;
    const scheduleView = () => {
      clearTimeout(viewTimer);
      if (viewVisible && !document.hidden && !analyticsViewed) {
        viewTimer = setTimeout(() => {
          if (viewVisible && !document.hidden && root.isConnected) trackView();
        }, 1000);
      }
    };
    if ('IntersectionObserver' in window && viewTarget) {
      const viewObserver = new IntersectionObserver((entries) => {
        viewVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5);
        scheduleView();
      }, { threshold: 0.5 });
      viewObserver.observe(viewTarget);
      document.addEventListener('vanemar:analytics-ready', scheduleView);
      document.addEventListener('visibilitychange', scheduleView);
      document.addEventListener('shopify:section:unload', function unload(event) {
        if (!event.target.contains(root)) return;
        viewObserver.disconnect();
        clearTimeout(viewTimer);
        document.removeEventListener('vanemar:analytics-ready', scheduleView);
        document.removeEventListener('visibilitychange', scheduleView);
        document.removeEventListener('shopify:section:unload', unload);
      });
    }

    const rebuildFlow = () => {
      // Yalnızca gerçekten cevap isteyen konular bir ekrana dönüşür. Schema'da
      // desteklenen `answer_style: none` seçimlerinin template'i bilerek yoktur;
      // bunları adım sanmak sihirbazı görünmez bir ekranda kilitliyordu.
      const questionSteps = answers.needs
        .filter((id) => needTemplates[id])
        .map((id) => needStepEls[id] || id);
      flow = [needsStep, ...questionSteps, resultStep];
    };

    // Ayrı fonksiyon: konu seçimi değiştiği anda da çağrılır, böylece gösterge
    // adım atılmadan güncellenir. "2 konu seçtim ama hâlâ ADIM 1/2 yazıyor,
    // demek ki soru sorulmayacak" yanılgısının sebebi buydu.
    //
    // Hiç konu seçilmemişken gösterge hiç görünmez: "1 / 2" demek, akışın kaç
    // adım olacağı daha belli değilken sayı uydurmak olurdu. `visibility` ile
    // gizlenir (display değil) — yer ayrılı kalır, yazı belirince seçenek
    // listesi aşağı zıplamaz.
    const syncProgress = () => {
      const started = current > 0 || answers.needs.length > 0;
      if (progress) progress.classList.toggle('is-idle', !started);
      const pct = flow.length > 1 ? (current / (flow.length - 1)) * 100 : 100;
      if (progressBar) progressBar.style.width = pct + '%';
      if (progressText) progressText.textContent = `${strings.step} ${current + 1} / ${flow.length}`;
    };

    const showStep = (index, moveFocus) => {
      current = Math.min(Math.max(index, 0), flow.length - 1);
      root.querySelectorAll('[data-vmw-step]').forEach((s) => { s.hidden = true; });
      let el = flow[current];
      if (typeof el === 'string') {
        el = ensureNeedStep(el);
        flow[current] = el;
      }
      if (!el) return;
      el.hidden = false;
      syncProgress();
      if (analyticsStartedAt !== null) trackStep();

      // Adım DEĞİŞİNCE başlığa odaklan: ekran okuyucu yeni soruyu duyar.
      // Sayfa ilk açılırken odaklanmaz — açılışta kimse adım değiştirmedi ve
      // odak halkası başlığın etrafında çerçeve gibi görünüyordu.
      if (moveFocus === false) return;
      const legend = el.querySelector('.vmw-q');
      if (legend) {
        legend.setAttribute('tabindex', '-1');
        legend.focus({ preventScroll: true });
      }
    };

    /* ---------- Öneri hesabı ----------
       Adet, kullanıcının teknesi hakkında söylediğinden çıkar:
         adet = söylediği sayı − Gateway'in zaten karşıladığı kadarı
       Akü için freeCovered=1'dir; Gateway bağlı olduğu grubu kendi ölçer, o
       yüzden tek gruplu teknede akü sensörü ÖNERİLMEZ. */
    const buildRecommendation = () => {
      const out = [];
      const seen = new Set();

      if (catalog.gateway && !answers.skipGateway) {
        out.push({ ...catalog.gateway, qty: 1, required: true, why: catalog.gateway.reason });
        seen.add(catalog.gateway.id);
      }

      catalog.items.forEach((item) => {
        if (answers.needs.indexOf(item.need) === -1) return;

        // Adet artık şıkkın karşılığı; sıfır çıkarsa (ör. "yalnızca Gateway'in
        // bağlı olduğu akü") o ürün hiç önerilmez. Alan bazlı sorularda cevap
        // ürün başına bir nesnedir: her ürün yalnızca KENDİ satırlarının
        // toplamını alır.
        const said = answers.qty[item.need];
        let qty;
        if (said !== null && typeof said === 'object') {
          const scopedQty = said[item.slot] || 0;
          // Kapsam sorularında da "ikinci ürün adetle çarpılsın" ayarına uy.
          // Örn. çok sayıda giriş sensörüne karşı tek hareket sensörü gerekir.
          qty = item.scales ? scopedQty : (scopedQty > 0 ? 1 : 0);
        } else {
          const base = said === undefined ? 1 : said;
          qty = item.scales ? base : (base > 0 ? 1 : 0);
        }
        if (qty < 1) return;

        if (seen.has(item.id)) {
          // Aynı ürün birden fazla konuyu karşılıyorsa iki kez listelenmez;
          // gerekçesi birleşir, adedi en yükseğe çekilir.
          const already = out.find((o) => o.id === item.id);
          if (already) {
            if (already.why.indexOf(item.needLabel) === -1) already.why += ' · ' + item.needLabel;
            already.qty = Math.max(already.qty, qty);
          }
          return;
        }
        // Gerekçe: hangi konu için ve hangi alanlarda — "Yangın · Kamaralar (3), Mutfak"
        const detail = answers.detail[item.need];
        seen.add(item.id);
        out.push({ ...item, qty, required: false, why: detail ? item.needLabel + ' · ' + detail : item.needLabel });
      });

      return out;
    };

    const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    ));

    // Shopify'ın kendi money_format'ı — satır fiyatları `money` filtresinden
    // geliyor, toplam da aynı biçimde çıksın diye. Intl kullanılsaydı aynı
    // kutuda iki farklı para birimi biçimi olurdu.
    const moneyFormat = config.moneyFormat || '\u007b\u007bamount\u007d\u007d';
    const groupNumber = (cents, decimals, thousands, decimal) => {
      const fixed = (Math.abs(cents) / 100).toFixed(decimals);
      const parts = fixed.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return decimals > 0 ? whole + decimal + parts[1] : whole;
    };
    const formatMoney = (cents) => moneyFormat
      .replace(/<[^>]*>/g, '')
      .replace(/\{\{\s*(\w+)\s*\}\}/g, (_m, name) => {
        switch (name) {
          case 'amount_no_decimals': return groupNumber(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return groupNumber(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return groupNumber(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return groupNumber(cents, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return groupNumber(cents, 0, ' ', ',');
          case 'amount_with_space_separator': return groupNumber(cents, 2, ' ', ',');
          case 'amount_with_period_and_space_separator': return groupNumber(cents, 2, ' ', '.');
          default: return groupNumber(cents, 2, ',', '.');
        }
      });

    const renderResult = () => {
      const items = buildRecommendation();
      statusEl.textContent = '';
      statusEl.classList.remove('is-success');
      addAllLabel.textContent = strings.addAll;

      // Gateway öneride kalan tek ürün olsa bile kutu görünmeye devam etmeli.
      // Kullanıcı onu çıkardığında sonuç boşalabilir; kutuyu da kaldırırsak bu
      // kararı geri almasının tek yolu sihirbazı baştan başlatmak olur.
      const gatewayToggle = catalog.gateway
        ? `<label class="vmw-own">
             <input type="checkbox" data-vmw-skip-gateway ${answers.skipGateway ? 'checked' : ''}>
             <span>${escapeHtml(strings.ownGateway)}</span>
           </label>`
        : '';
      const bindGatewayToggle = () => {
        resultEl.querySelector('[data-vmw-skip-gateway]')?.addEventListener('change', (e) => {
          answers.skipGateway = e.target.checked;
          renderResult();
        });
      };

      if (!items.length) {
        resultEl.innerHTML = '<p class="vmw-empty">' + escapeHtml(strings.empty) + '</p>' + gatewayToggle;
        addAllBtn.disabled = true;
        bindGatewayToggle();
        return;
      }

      const buyable = items.filter((i) => i.available);
      addAllBtn.disabled = buyable.length === 0;

      const rows = items.map((i) => `
        <div class="vmw-item${i.required ? ' vmw-item--required' : ''}">
          <span class="vmw-item__media">${i.image ? `<img src="${escapeHtml(i.image)}" alt="" width="52" height="52" loading="lazy">` : ''}</span>
          <span class="vmw-item__info">
            <a href="${escapeHtml(i.url)}">${i.qty > 1 ? `<span class="vmw-item__qty">${i.qty}×</span>` : ''}${escapeHtml(i.title)}${i.required ? `<span class="vmw-item__badge">${escapeHtml(strings.required)}</span>` : ''}</a>
            <span class="vmw-item__why">${escapeHtml(i.why || '')}</span>
          </span>
          ${i.available
            ? `<span class="vmw-item__price">${escapeHtml(formatMoney(i.cents * i.qty))}</span>`
            : `<span class="vmw-item__soldout">${escapeHtml(strings.soldout)}</span>`}
        </div>
      `).join('');

      // Toplam yalnızca sepete gerçekten girecek kalemleri sayar; tükenmiş bir
      // ürünün fiyatını toplamak, ödemede çıkmayacak bir rakam vaat etmek olur.
      const totalCents = buyable.reduce((sum, i) => sum + i.cents * i.qty, 0);
      const total = buyable.length > 1
        ? `<div class="vmw-total">
             <span class="vmw-total__label">${escapeHtml(strings.totalLabel)}</span>
             <span class="vmw-total__value">${escapeHtml(formatMoney(totalCents))}</span>
           </div>`
        : '';

      resultEl.innerHTML = rows + total + gatewayToggle;
      bindGatewayToggle();
    };

    /* ---------- Cevapların okunması ----------
       Adet, kullanıcının seçtiği ŞIKKIN karşılığıdır; kullanıcı sensör saymaz.
         choices → şıkkın kendi değeri (ör. "Servis ve marş aküsü" = 1 sensör)
                   "Kendim belirlemek istiyorum" ise girdiği sayı − customOffset
                   (akü için offset 1: Gateway zaten bir grubu ölçüyor)
         areas   → işaretlenen alanların adetleri toplamı */
    const readQuantity = (input) => {
      if (!input) return { value: 0, valid: false };
      const value = Number(input.value);
      const min = input.min === '' ? 1 : Number(input.min);
      const max = input.max === '' ? Number.MAX_SAFE_INTEGER : Number(input.max);
      const valid = input.value !== '' && Number.isInteger(value) && value >= min && value <= max;
      input.setAttribute('aria-invalid', valid ? 'false' : 'true');
      return { value: valid ? value : 0, valid };
    };

    const readNeedAnswer = (needId) => {
      const stepEl = needStepEls[needId];
      if (!stepEl) return { qty: 1, detail: '', answered: true };

      const picked = stepEl.querySelector('[data-vmw-choice]:checked');
      if (picked) {
        if (picked.value === 'custom') {
          const input = stepEl.querySelector('[data-vmw-custom-input]');
          const quantity = readQuantity(input);
          const off = (catalog.items.find((i) => i.need === needId) || {}).customOffset || 0;
          return {
            qty: Math.max(0, quantity.value - off),
            detail: '',
            answered: quantity.valid
          };
        }
        const label = picked.closest('.vmw-choice').querySelector('.vmw-choice__label');
        return {
          qty: parseInt(picked.value, 10) || 0,
          detail: label ? label.textContent.trim() : '',
          answered: true
        };
      }

      const areas = [...stepEl.querySelectorAll('[data-vmw-area]:checked')];
      if (areas.length) {
        // Ürün başına ayrı toplam: satırlar hangi ürüne sayılacaksa oraya
        // yazılır. Tek soruda iki cevap toplamanın mekanizması bu — kapı
        // sensörü kapak sayısı kadar, hareket sensörü kendi satırı kadar.
        const perSlot = { 1: 0, 2: 0 };
        const bits = [];
        let quantitiesValid = true;
        areas.forEach((cb) => {
          const row = cb.closest('.vmw-area');
          const quantity = readQuantity(row.querySelector('[data-vmw-area-qty]'));
          const q = quantity.value;
          quantitiesValid = quantitiesValid && quantity.valid;
          perSlot[cb.dataset.vmwAreaSlot === '2' ? 2 : 1] += q;
          bits.push(cb.value + (q > 1 ? ' (' + q + ')' : ''));
        });
        return { qty: perSlot, detail: bits.join(', '), answered: quantitiesValid };
      }

      // Bu adımda hiçbir şey seçilmemiş.
      return { qty: 0, detail: '', answered: stepEl.querySelector('[data-vmw-choice], [data-vmw-area]') === null };
    };

    const syncAnswers = () => {
      answers.needs.forEach((id) => {
        const a = readNeedAnswer(id);
        answers.qty[id] = a.qty;
        answers.detail[id] = a.detail;
      });
    };

    /* ---------- Girdi dinleyicileri ---------- */
    const syncNav = () => {
      const el = flow[current];
      if (!el || typeof el === 'string') return;
      const next = el.querySelector('[data-vmw-next]');
      if (!next) return;
      if (el === needsStep) {
        next.disabled = answers.needs.length === 0;
      } else if (el.dataset.vmwNeedStep) {
        next.disabled = !readNeedAnswer(el.dataset.vmwNeedStep).answered;
      }
      // Sondan bir önceki adımda buton "Devam" değil, "Önerimi göster" der —
      // kullanıcı kaç soru kaldığını saymak zorunda kalmasın. Henüz hiçbir
      // konu seçilmemişken ise her zaman "Devam": akışın kaç adım olacağı o
      // an belli değilken "Önerimi göster" vaat etmek yanıltıcı olur.
      const goesToResult = flow[current + 1] === resultStep;
      if (el === needsStep && answers.needs.length === 0) {
        next.textContent = strings.next;
      } else {
        next.textContent = goesToResult ? strings.finish : strings.next;
      }
    };

    root.querySelectorAll('[data-vmw-need]').forEach((input) => {
      input.addEventListener('change', () => {
        answers.needs = [...root.querySelectorAll('[data-vmw-need]')]
          .filter((i) => i.checked)
          .map((i) => i.value);
        rebuildFlow();
        // Gösterge anında güncellensin: 2 konu seçildiyse "Adım 1 / 4" olur,
        // kullanıcı soruların geleceğini daha Devam'a basmadan görür.
        syncProgress();
        syncNav();
        startTracking();
      });
    });

    // Sonradan template'ten kurulan soru alanları için olaylar form üzerinde
    // yakalanır; her yeni düğüme ayrı dinleyici bağlanmaz.
    form.addEventListener('change', (event) => {
      const input = event.target;
      if (input.matches('[data-vmw-choice]')) {
        const needId = input.dataset.vmwChoice;
        const custom = root.querySelector('[data-vmw-custom="' + needId + '"]');
        if (custom) {
          custom.hidden = input.value !== 'custom';
          if (input.value === 'custom') custom.querySelector('input')?.focus();
        }
        syncNav();
        return;
      }

      if (input.matches('[data-vmw-area]')) {
        const wrap = input.closest('.vmw-area').querySelector('[data-vmw-area-qtywrap]');
        if (wrap) wrap.hidden = !input.checked;
        syncNav();
      }
    });

    form.addEventListener('input', (event) => {
      if (event.target.matches('[data-vmw-custom-input], [data-vmw-area-qty]')) syncNav();
    });

    form.addEventListener('click', (event) => {
      const qtyButton = event.target.closest('[data-vmw-area-minus], [data-vmw-area-plus]');
      if (qtyButton && form.contains(qtyButton)) {
        const input = qtyButton.closest('.vmw-area').querySelector('[data-vmw-area-qty]');
        const delta = qtyButton.matches('[data-vmw-area-minus]') ? -1 : 1;
        const value = (parseInt(input.value, 10) || 1) + delta;
        input.value = Math.min(20, Math.max(1, value));
        syncNav();
        return;
      }

      // Kapsam satırında yalnız metin/checkbox değil, kartın boş kalan tüm
      // yüzeyi de seçim alanıdır. Adet kontrolü ayrı bir etkileşim olduğundan
      // onun içinde tıklamak seçimi yanlışlıkla kapatmaz.
      const areaRow = event.target.closest('.vmw-area');
      if (areaRow && form.contains(areaRow)) {
        const clickedPicker = event.target.closest('.vmw-area__pick');
        const clickedQuantity = event.target.closest('[data-vmw-area-qtywrap]');
        if (!clickedPicker && !clickedQuantity) {
          const checkbox = areaRow.querySelector('[data-vmw-area]');
          if (checkbox) {
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            checkbox.focus({ preventScroll: true });
          }
        }
        return;
      }

      const nextButton = event.target.closest('[data-vmw-next]');
      if (nextButton && form.contains(nextButton)) {
        if (nextButton.disabled) return;
        startTracking();
        rebuildFlow();
        syncAnswers();
        const target = current + 1;
        if (flow[target] === resultStep) renderResult();
        showStep(target);
        syncNav();
        if (flow[current] === resultStep && !analyticsCompleted) {
          analyticsCompleted = trackWizard('wizard_complete', {
            wizard_steps_total: flow.length,
            duration_ms: elapsed()
          });
        }
        return;
      }

      const backButton = event.target.closest('[data-vmw-back]');
      if (backButton && form.contains(backButton)) {
        startTracking();
        showStep(current - 1);
        syncNav();
      }
    });

    root.querySelector('[data-vmw-restart]')?.addEventListener('click', () => {
      if (analyticsStartedAt !== null) trackWizard('wizard_restart', { duration_ms: elapsed() });
      analyticsStartedAt = null;
      analyticsCompleted = false;
      analyticsRun += 1;
      answers.needs = [];
      answers.qty = {};
      answers.detail = {};
      answers.skipGateway = false;
      form.reset();
      root.querySelectorAll('[data-vmw-custom], [data-vmw-area-qtywrap]').forEach((el) => { el.hidden = true; });
      resultEl.innerHTML = '';
      statusEl.textContent = '';
      rebuildFlow();
      showStep(0, false);
      syncNav();
    });

    /* ---------- Sepete ekleme ----------
       Sepete ürün kimlikleri gider. Analytics yalnızca eklemenin başarılı
       olup olmadığını ölçer; hangi soruya ne cevaplandığı hiçbir yere gitmez. */
    addAllBtn?.addEventListener('click', async () => {
      const items = buildRecommendation().filter((i) => i.available);
      if (!items.length) return;

      addAllBtn.disabled = true;
      statusEl.textContent = '';
      statusEl.classList.remove('is-success');

      let cartRequestSucceeded = false;
      try {
        const res = await fetch(config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items.map((i) => ({ id: i.id, quantity: i.qty || 1 })) })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || strings.error);
        }
        cartRequestSucceeded = true;
        trackWizard('wizard_add_to_cart', { duration_ms: elapsed() });
        let cart = null;
        try {
          const cartRes = await fetch(config.cartUrl, { headers: { 'Accept': 'application/json' } });
          if (cartRes.ok) cart = await cartRes.json();
        } catch (cartError) {
          // Ürünler zaten eklendi; yalnızca rozet yenilemesi başarısız oldu.
        }
        // Başlıktaki rozet — main-product.liquid ile aynı kanca.
        if (cart) {
          document.querySelectorAll('[data-cart-count]').forEach((b) => {
            b.textContent = cart.item_count;
            b.style.display = cart.item_count ? '' : 'none';
          });
          document.querySelectorAll('[data-cart-link]').forEach((l) => {
            const label = l.dataset.cartLabel;
            if (label) l.setAttribute('aria-label', cart.item_count ? label + ' (' + cart.item_count + ')' : label);
          });
        }
        const addedQuantity = items.reduce((sum, item) => sum + (item.qty || 1), 0);
        const addedProductTitles = items.map((item) => item.title).filter(Boolean).join(', ');
        if (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { itemCount: cart.item_count }
          }));
        }
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: {
            itemCount: cart?.item_count,
            productTitle: addedProductTitles,
            variantTitle: '',
            quantity: addedQuantity,
            message: strings.added,
            items: items.map((item) => ({
              id: item.id,
              productTitle: item.title,
              quantity: item.qty || 1
            }))
          }
        }));
        statusEl.textContent = strings.added;
        statusEl.classList.add('is-success');
        addAllLabel.textContent = strings.added;
      } catch (err) {
        if (!cartRequestSucceeded) trackWizard('wizard_cart_error', { error_type: 'cart_request_failed' });
        statusEl.textContent = err.message || strings.error;
        addAllBtn.disabled = false;
      }
    });

    /* ---------- Devreye alma ----------
       İlk ekran HTML'de görünür, fakat gezinme ve sonuç üretimi JS gerektirir.
       Etkileşimli sihirbaz davranışı yalnızca burada başlar. */
    form.classList.add('is-ready');
    if (progress) progress.hidden = false;
    rebuildFlow();
    showStep(0, false);
    syncNav();
    };

    if (root.dataset.vmwDefer !== 'true') {
      initWizard();
    } else {
      const deferredRoot = root;

      let bootObserver = null;
      const bootWizard = () => {
        if (bootObserver) bootObserver.disconnect();
        deferredRoot.removeEventListener('pointerdown', bootWizard);
        deferredRoot.removeEventListener('focusin', bootWizard);
        if (deferredRoot.isConnected) initWizard();
      };

      /* Collections place this section below the product grids. Avoid their
         JSON/DOM setup during LCP, while guaranteeing that direct interaction
         and keyboard navigation never wait for the observer callback. */
      deferredRoot.addEventListener('pointerdown', bootWizard, { once: true, passive: true });
      deferredRoot.addEventListener('focusin', bootWizard, { once: true });

      if ('IntersectionObserver' in window) {
        bootObserver = new IntersectionObserver(function(entries) {
          if (entries.some(function(entry) { return entry.isIntersecting; })) bootWizard();
        }, { rootMargin: '600px 0px', threshold: 0 });
        bootObserver.observe(deferredRoot);
      } else {
        bootWizard();
      }
    }
  }

  function boot(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-vmw]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-vmw]')));
    }
    roots.forEach(setupWizard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
